export const conditionalMap = <T>(
  array: T[],
  conditionFn: (arrayItem: T) => boolean,
  newArrayItem: (arrayItem: T) => T,
) =>
  array.map(arrayItem => {
    if (conditionFn(arrayItem)) {
      return newArrayItem(arrayItem);
    } else {
      return arrayItem;
    }
  });

export const filterTruthy = <T>(value: T): value is Exclude<T, false | null | undefined | '' | 0> => Boolean(value);
